export enum PlanRoutes {
  ROOT = '',
  CREATE = 'create',
  ADD_DRILL = 'add-drill',
  SET_TARGET = 'set-target',
  DETAIL = 'detail',
  EDIT = 'edit'
}
